export const environment = {
  version: '1.35',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
